"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchSourcesSchema = void 0;
var zod_1 = require("zod");
var content_resource_1 = require("./content-resource");
var source_fetcher_1 = require("./source-fetcher");
exports.FetchSourcesSchema = zod_1.z
    .function()
    .args(zod_1.z.array(content_resource_1.ContentResourceSchema))
    .returns(zod_1.z.promise(zod_1.z.array(source_fetcher_1.SourceFetcherResultSchema)));
//# sourceMappingURL=fetch-sources.js.map